export const replaceLocation = path => window.location.replace(path)
